(function (global, factory) {
  if (typeof define === "function" && define.amd) {
    define(['exports', './assign', './defaults', './mapKeys', './mapValues', './merge', './omit', './omitBy', './pick', './pickBy', './set', './unset', './update'], factory);
  } else if (typeof exports !== "undefined") {
    factory(exports, require('./assign'), require('./defaults'), require('./mapKeys'), require('./mapValues'), require('./merge'), require('./omit'), require('./omitBy'), require('./pick'), require('./pickBy'), require('./set'), require('./unset'), require('./update'));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports, global.assign, global.defaults, global.mapKeys, global.mapValues, global.merge, global.omit, global.omitBy, global.pick, global.pickBy, global.set, global.unset, global.update);
    global.index = mod.exports;
  }
})(this, function (exports, _assign, _defaults, _mapKeys, _mapValues, _merge, _omit, _omitBy, _pick, _pickBy, _set, _unset, _update) {
  'use strict';

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.update = exports.unset = exports.set = exports.pickBy = exports.pick = exports.omitBy = exports.omit = exports.merge = exports.mapValues = exports.mapKeys = exports.defaults = exports.assign = undefined;
  exports.assign = _assign.assign;
  exports.defaults = _defaults.defaults;
  exports.mapKeys = _mapKeys.mapKeys;
  exports.mapValues = _mapValues.mapValues;
  exports.merge = _merge.merge;
  exports.omit = _omit.omit;
  exports.omitBy = _omitBy.omitBy;
  exports.pick = _pick.pick;
  exports.pickBy = _pickBy.pickBy;
  exports.set = _set.set;
  exports.unset = _unset.unset;
  exports.update = _update.update;
});